let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iR0Uw")).then(() => parcelRequire('88oIq'));